export default __webpack_public_path__ + "static/media/ponentes__LeonardoBeltran.ef709b30.jpg";